import store from '@/store'
import { initialAbility } from '@/libs/acl/config'

const getUserRights = () => (((store.getters.myOwnProjects.length) ||
    (store.getters.additionalProjects.length) ||
    (store.getters.projects.length)) &&
    store.getters.userRights) || []

const getUserService = (serviceName) => {
    const userRights = getUserRights()
    const items = userRights.filter(right => right.serviceName === serviceName)
    if (items.length) {
        return items[0]
    }
    return {}
}

const createAbility = () => {
    const userRights = getUserRights()
    return userRights.reduce((arr, right) => {
        if (right.serviceType === 'plugin') {
            arr.push({ action: 'READ', subject: right.serviceName })
        }
        return arr.concat(right.permissions.map(permission => ({ action: permission, subject: right.serviceName })))
    }, []).concat(initialAbility)
}

export {
    getUserRights,
    getUserService,
    createAbility
}
